import localMapImage from "./assets/design-map-hd.jpg";
import "./map.css";
const DesignMapUrl = localMapImage;

const ItemPositions = {
  CQRS: { x: 165, y: 63, width: 58, height: 50 },
  CQS: { x: 267, y: 80, width: 62, height: 50 },
  controlling_side_effects: { x: 399, y: 104, width: 91, height: 63 },
  low_coupling: { x: 513, y: 142, width: 115, height: 69 },
  facade: { x: 47, y: 111, width: 90, height: 50 },
  adapter: { x: 161, y: 136, width: 79, height: 50 },
  mediator: { x: 87, y: 166, width: 67, height: 50 },
  chain_of_responsibility: { x: 4, y: 183, width: 78, height: 80 },
  builder: { x: 117, y: 245, width: 88, height: 50 },
  protected_variation: { x: 355, y: 199, width: 89, height: 58 },
  events: { x: 140, y: 313, width: 90, height: 50 },
  observer: { x: 239, y: 276, width: 87, height: 66 },
  hexagonal_architecture: { x: 346, y: 285, width: 81, height: 67 },
  DDD: { x: 279, y: 342, width: 64, height: 76 },
  high_cohesion: { x: 395, y: 359, width: 79, height: 63 },
  MVC: { x: 74, y: 416, width: 50, height: 50 },
  factory: { x: 47, y: 473, width: 50, height: 50 },
  pure_fabrication: { x: 170, y: 462, width: 70, height: 59 },
  command: { x: 62, y: 538, width: 54, height: 50 },
  iterator: { x: 183, y: 583, width: 50, height: 50 },
  information_expert: { x: 301, y: 461, width: 66, height: 62 },
  creator: { x: 290, y: 564, width: 58, height: 50 },
  bridge: { x: 394, y: 529, width: 61, height: 50 },
  state: { x: 444, y: 466, width: 53, height: 50 },
  visitor: { x: 535, y: 504, width: 63, height: 50 },
  levels_of_abstraction: { x: 532, y: 280, width: 68, height: 50 },
  memento: { x: 600, y: 226, width: 50, height: 28 },
  expressive_code: { x: 666, y: 202, width: 126, height: 87 },
  encapsulation: { x: 607, y: 334, width: 65, height: 50 },
  polymorphism: { x: 541, y: 402, width: 64, height: 50 },
  abstract_factory: { x: 786, y: 352, width: 64, height: 50 },
  factory_method: { x: 755, y: 408, width: 65, height: 50 },
  template_method: { x: 661, y: 423, width: 55, height: 50 },
  decorator: { x: 729, y: 465, width: 63, height: 50 },
  strategy: { x: 635, y: 487, width: 58, height: 50 },
  proxy: { x: 713, y: 525, width: 56, height: 50 },
  prototype: { x: 535, y: 574, width: 62, height: 50 },
  composite: { x: 629, y: 549, width: 50, height: 50 },
  interpreter: { x: 677, y: 599, width: 65, height: 50 },
  indirection: { x: 264, y: 171, width: 77, height: 50 },
  ease_of_change: { x: 502, y: 35, width: 131, height: 32 },
  world_of_software_design: { x: 710, y: 30, width: 260, height: 118 },
};

const MapWidth = 1000;
const MapHeight = 665;

export function Map({ openItem, searchInput }) {
  function onItemClick(e, title) {
    e.preventDefault();
    openItem(title.replaceAll("_", "-"));
  }

  return (
    <svg
      className="map-img"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      viewBox={`0 0 ${MapWidth} ${MapHeight}`}
    >
      <image
        href={DesignMapUrl}
        alt="Map of design"
        width={MapWidth}
        height={MapHeight}
      ></image>
      {Object.entries(ItemPositions).map(([topic, position]) => (
        <rect
          onClick={(e) => onItemClick(e, topic)}
          cursor="pointer"
          x={position.x}
          y={position.y}
          width={position.width}
          height={position.height}
          style={{
            "stroke-width":
              searchInput != "" && new RegExp(searchInput).test(topic)
                ? "6"
                : "0",
            stroke: "orange",
            fill: "rgb(0,0,0,0)",
          }}
          aria-label={topic}
          key={topic}
        />
      ))}
    </svg>
  );
}
